// extracted by mini-css-extract-plugin
var _1 = "pagesSection-module__pagesSection___gloyh";
export { _1 as "pagesSection" }
